import { useEffect, useState } from "react";
import { apiRequest } from "../api";

export default function InvoiceTypesView() {
    const [poTypeName, setPoTypeName] = useState("");
    const [poTypeDescription, setPoTypeDescription] = useState("");
    const [existingPOs, setExistingPOs] = useState([]);
    const [poTypeLoading, setPoTypeLoading] = useState(false);
    const [poTypeSaving, setPoTypeSaving] = useState(false);
    const [poTypeStatus, setPoTypeStatus] = useState("");
    const [poTypeError, setPoTypeError] = useState("");

    async function loadInvoiceTypes() {
        setPoTypeLoading(true);
        setPoTypeError("");
        try {
            const response = await apiRequest("/invoice-types/");
            setExistingPOs(Array.isArray(response?.data) ? response.data : []);
        } catch (requestError) {
            setPoTypeError(requestError.message || "Unable to load invoice types.");
        } finally {
            setPoTypeLoading(false);
        }
    }

    useEffect(() => {
        loadInvoiceTypes();
    }, []);

    async function handlePoTypeSubmit(event) {
        event.preventDefault();

        const name = poTypeName.trim();
        const description = poTypeDescription.trim();

        if (!name || !description) {
            return;
        }

        setPoTypeSaving(true);
        setPoTypeStatus("");
        setPoTypeError("");

        try {
            const response = await apiRequest("/invoice-types/", {
                method: "POST",
                body: {
                    name,
                    description,
                },
            });

            setExistingPOs(Array.isArray(response?.data) ? response.data : []);
            setPoTypeStatus(response?.message || "Invoice type saved successfully.");
            setPoTypeName("");
            setPoTypeDescription("");
        } catch (requestError) {
            setPoTypeError(requestError.message || "Unable to save invoice type.");
        } finally {
            setPoTypeSaving(false);
        }
    }

    return (
        <section className="teams-view teams-view--invoice-types">
            <div className="workspace-panel teams-view__hero">
                <div>
                    <h2>Invoice Type Management</h2>
                </div>
                <div className="teams-view__summary">
                    <span className="teams-view__summary-count">{existingPOs.length}</span>
                    <span className="teams-view__summary-label">invoice types configured</span>
                </div>
            </div>

            {poTypeStatus ? <div className="config-banner config-banner--success">{poTypeStatus}</div> : null}
            {poTypeError ? <div className="config-banner config-banner--error">{poTypeError}</div> : null}

            <div className="teams-layout">
                <form className="workspace-panel teams-form" onSubmit={handlePoTypeSubmit}>
                    <div className="users-form__header">
                        <div>
                            <p className="eyebrow">Create Invoice Type</p>
                            <h2>Add a new invoice type</h2>
                        </div>
                    </div>

                    <label className="config-field">
                        <span>Invoice Type Name</span>
                        <input
                            type="text"
                            value={poTypeName}
                            onChange={(event) => setPoTypeName(event.target.value)}
                            placeholder="e.g. Finance, Material, Operations"
                            required
                        />
                    </label>

                    <label className="config-field">
                        <span>Description</span>
                        <textarea
                            value={poTypeDescription}
                            onChange={(event) => setPoTypeDescription(event.target.value)}
                            placeholder="Enter description for this invoice type"
                            rows={4}
                            required
                        />
                    </label>

                    <button className="primary-button" type="submit" disabled={poTypeSaving}>
                        {poTypeSaving ? "Saving..." : "Submit"}
                    </button>
                </form>

                <div className="workspace-panel">
                    <div className="teams-table__header">
                        <div>
                            <p className="eyebrow">Directory</p>
                            <h2>Existing Invoice Types</h2>
                        </div>
                    </div>

                    <div className="config-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>Invoice Type Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {poTypeLoading ? (
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "center", color: "#999" }}>
                                            Loading invoice types...
                                        </td>
                                    </tr>
                                ) : existingPOs.length ? (
                                    existingPOs.map((po, index) => (
                                        <tr key={`${po.name}-${index}`}>
                                            <td>{po.name}</td>
                                            <td>{po.description}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "center", color: "#999" }}>
                                            No invoice types added yet.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}
